import { convertDateToReadableDate } from '@/services/utils/dateUtils';

const HasMissionDetailMixin = {
  computed: {
    humanStart() {
      if (this.mission && this.mission.start) {
        return convertDateToReadableDate(this.mission.start);
      }
      return '';
    },

    humanEnd() {
      if (this.mission && this.mission.end) {
        return convertDateToReadableDate(this.mission.end);
      }
      return '';
    },

    isOutsourcing() {
      return (
        this.$route && this.$route.params && this.$route.params.outsourcingToken
      );
    },

    hasCoupons() {
      return (
        this.missionDetail &&
        this.missionDetail.rental_coupons &&
        this.missionDetail.rental_coupons.length > 0
      );
    },

    disableChangeDumpBodyMessage() {
      if (!this.hasCoupons) return null;

      // can't change dumpBody if there is at least one pending coupon
      const hasOnePendingCoupon = this.missionDetail.rental_coupons.some(
        coupon => coupon.status === 'save',
      );
      if (hasOnePendingCoupon) {
        return "Vous ne pouvez pas changer la remorque car il vous reste au moins un BL en attente d'envoi.";
      }

      return null;
    },
  },
};

export default HasMissionDetailMixin;
